import React from "react";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="about-page">
      <div className="label-eyebrow">About us</div>
      <h1 className="font-display font-black text-4xl md:text-5xl mt-2 tracking-tight">Built in Canada, for Canadians and newcomers.</h1>
      <p className="mt-6 text-[#4B5563] leading-relaxed text-lg">
        TeachMeOnline.ca is a friendly, affordable online learning platform offering self-paced courses
        in language, healthcare basics, education, skilled trades, business, employment skills, and
        personal development — with Canadian context throughout.
      </p>

      <div className="mt-12 grid md:grid-cols-2 gap-8">
        <div className="bg-white border border-[#E5E7EB] rounded-2xl p-6">
          <h2 className="font-display font-bold text-xl">Our mission</h2>
          <p className="mt-2 text-[#4B5563]">Practical, accessible learning that helps people thrive in Canada — at home, at school and at work.</p>
        </div>
        <div className="bg-white border border-[#E5E7EB] rounded-2xl p-6">
          <h2 className="font-display font-bold text-xl">What we believe</h2>
          <p className="mt-2 text-[#4B5563]">Education should be affordable, flexible, and respectful of every learner's background and pace.</p>
        </div>
      </div>

      <div className="mt-12 bg-[#064E3B] text-white rounded-2xl p-8">
        <div className="label-eyebrow text-[#FECACA]">Important note</div>
        <p className="mt-2 leading-relaxed">
          Our courses provide general educational information. They are <strong>not</strong> accredited,
          government-approved, or licensed. They do not guarantee employment, immigration outcomes,
          or professional certification. For regulated topics (healthcare, legal, financial, immigration),
          please consult a qualified professional.
        </p>
      </div>
    </div>
  );
}
